import { z } from 'zod';

export const formSchema = z.object({
  ma_ngv: z.string().optional(),
  ma_so_thue: z.string().optional(),
  ten_kh_thue: z.string().optional(),
  dia_chi: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_ct: z.string().optional(),
  ong_ba: z.string().optional(),
  e_mail: z.string().optional(),
  ngay_ct: z.string().optional(),
  so_ct0: z.string().optional(),
  so_ct2: z.string().optional(),
  ngay_ct0: z.string().optional(),
  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),
  status: z.string().optional(),
  transfer_yn: z.boolean().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_ngv: '1',
  ma_so_thue: '',
  ten_kh_thue: '',
  dia_chi: '',
  dien_giai: '',
  ma_ct: '1',
  ong_ba: '',
  e_mail: '',
  ngay_ct: new Date().toISOString().split('T')[0],
  so_ct0: '',
  so_ct2: '',
  ngay_ct0: new Date().toISOString().split('T')[0],
  ma_nt: '',
  ty_gia: 1,
  status: '5',
  transfer_yn: false
};

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
